<div class="multi">
  <section class="content-header">
    <div class="container-fluid">
      <div class="video-settings">
        <div class="setting-group">
          <h1><i class="fas fa-camera"></i> Multi View</h1>
        </div>
        <div class="setting-group">
          <h1 style="width: 220px;">{{ currentTime }}</h1>
        </div>
        <div class="setting-group">
          <h2 class="small" style="font-weight: bolder;">ストリーム名表示</h2>
          <mat-slide-toggle (change)="toggle()" [checked]="true"></mat-slide-toggle>
        </div>
      </div>
    </div>
  </section>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <gridster [options]="options" style="background-color: #999999; box-shadow: 0 0 6px #000;">
            <gridster-item *ngFor="let item of items;" [item]="item">
              <div class="capture-back-area" oncontextmenu="return false;"
              (mousedown)="mousedown($event)"
              (mouseup)="mouseup(item.streamId)">
                <div class="capture-back">
                  <gs-capture-multi id="{{ item.streamId }}" name="{{ item.streamName }}"></gs-capture-multi>
                </div>
                <div class="video-footer" *ngIf="isViewDeviceName">
                  <div class="text-right">
                    <span class="title">{{item.streamName}}</span>
                  </div>
                </div>
                <div class="video-header">
                  <div class="text-right">
                    <span class="title">LIVE</span>
                  </div>
                </div>
              </div>
            </gridster-item>
          </gridster>
          <div class="row video-container">
            <div class="col-12">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
